import { Flex, NumberInput } from '@mantine/core';
import { PaginationMeta } from 'common/repositories/common.model';
import { debounce } from 'lodash';
import Text from 'mantine-components/widget/text';
import React from 'react';
import UniskaiButton from 'templates/actions/uniskai-button';

export interface UniskaiPaginationProps {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  meta?: PaginationMeta;
}

export default function UniskaiPagination(props: UniskaiPaginationProps) {
  const [page, setPage] = React.useState(props.page);
  const { meta } = props;

  const onPress = React.useCallback(
    (type: 'prev' | 'next') => () => {
      let val = page;
      if (type === 'prev') {
        if (page === 0) return;
        val = page - 1;
      } else {
        if (page === meta?.lastPage) return;
        val = page + 1;
      }
      setPage(val);
      debounce(() => props.setPage(val), 1000)();
    },
    [meta?.lastPage, page, props],
  );

  return (
    <div>
      {meta && (
        <Text ta="center" my={8} color="gray">
          Show{' '}
          <Text color="black" span>
            {meta.from}-{meta.to}
          </Text>{' '}
          of {meta.total} items
        </Text>
      )}
      <Flex direction="row" align="center" justify="center" gap={6}>
        <UniskaiButton type="previous" isLite onClick={onPress('prev')} />
        <NumberInput
          maw={60}
          styles={{
            input: {
              textAlign: 'center',
            },
          }}
          onChange={(val) => {
            const value = typeof val === 'string' ? 1 : val;
            setPage(value);
            debounce(() => props.setPage(value), 1500)();
          }}
          value={page}
          max={meta?.lastPage}
        />
        {meta && <Text>of {meta.lastPage}</Text>}
        <UniskaiButton type="next" isLite onClick={onPress('next')} />
      </Flex>
    </div>
  );
}
